<div   class="margin-top-md">
  <span class="shipperLabel">{{ companyName | titlecase }}</span>
  <span>{{ shipment.shipmentID }}</span>
</div>
<mat-divider></mat-divider>
<div   class="margin-top-md margin-right-md ">
  <div >
    <span class="label">Phone</span>
    <span class="value">{{ companyDetails?.phoneNumber || '-' }} </span>
  </div>
  <div >
    <span class="label">Email</span>
    <span class="value">{{ companyDetails?.email || '-' }}</span>
  </div>
</div>

<span class="shipperLabel margin-top-lg ">Pickup</span>
<mat-divider></mat-divider>

<div  class="margin-top-md margin-right-md " >
  <div >
    <span class="label">Business name</span>
    <span class="value">{{ shipment?.pickup?.businessName | titlecase }}</span>
  </div>
  <div >
    <span class="label">contact name</span>
    <span class="value">{{ shipment?.pickup?.contactName | titlecase }}</span>
  </div>
</div>
<div class="margin-top-md margin-right-md  ">
  <span class="label">Address</span>
  <span class="value">
    @if (shipment?.pickup?.streetAddress) {
      <span>{{ shipment?.pickup?.streetAddress | titlecase }}</span>
    }
    @if (shipment?.pickup?.city) {
      <span>, {{ shipment?.pickup?.city | titlecase }}</span>
    }
    @if (shipment?.pickup?.state) {
      <span>, {{ shipment?.pickup?.state | uppercase }}</span>
    }
    @if (shipment?.pickup?.zipcode) {
      <span>, {{ shipment?.pickup?.zipcode | uppercase }}</span>
    }
  </span>
</div>
<div  class="margin-top-md margin-right-md  " >
  <div >
    <span class="label">Phone</span>
    <span class="value">{{ shipment?.pickup?.contactPhone }}</span>
  </div>
  <div >
    <span class="label">Email</span>
    <span class="value ">{{ shipment?.pickup?.contactEmail }}</span>
  </div>
</div>

<span class="shipperLabel margin-top-lg  ">Delivery</span>
<mat-divider></mat-divider>

<div  class="margin-top-md margin-right-md  " >
  <div >
    <span class="label">Business name</span>
    <span class="value">{{ shipment?.delivery?.businessName | titlecase }}</span>
  </div>
  <div >
    <span class="label">contact name</span>
    <span class="value ">{{ shipment?.delivery?.contactName | titlecase }}</span>
  </div>
</div>
<div class="margin-top-md margin-right-md  ">
  <span class="label">Address</span>
  <span class=" value ">
    @if (shipment?.delivery?.streetAddress) {
      <span>{{ shipment?.delivery?.streetAddress | titlecase }}</span>
    }
    @if (shipment?.delivery?.city) {
      <span>, {{ shipment?.delivery?.city | titlecase }}</span>
    }
    @if (shipment?.delivery?.state) {
      <span>, {{ shipment?.delivery?.state | uppercase }}</span>
    }
    @if (shipment?.delivery?.zipcode) {
      <span>, {{ shipment?.delivery?.zipcode | uppercase }}</span>
    }
  </span>
</div>
<div  class="margin-top-md margin-right-md  " >
  <div >
    <span class="label">Phone</span>
    <span class="value">{{ shipment?.delivery?.contactPhone }}</span>
  </div>
  <div >
    <span class="label">Email</span>
    <span class="value ">{{ shipment?.delivery?.contactEmail }}</span>
  </div>
</div>
